<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Excel</label>
            <v-file-uploader v-model="value" :accept="['xlsx','xls']" value-parameter="File"></v-file-uploader>
        </div>
        <div class="col-12 text-right mt-1">
            <button class="btn btn-sm btn-flat-success" v-on:click="getSample">
                <feather-icon icon="FileIcon"></feather-icon>
                &#214;rnek Excel
            </button>
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import Additional from '@/utilities/additional'
import OperationalParametersApi from '@/api/operational-parameters'

export default {
    components:{
        VFileUploader
    },
    props:{
        value:Object
    },
    methods:{
        getSample(){
            OperationalParametersApi.TrafficFine.GetSampleExcel().then(res => {
                Additional.DownloadFile(res.data, 'TrafikCezasi_Ornek.xlsx')
            })
        }
    }
}
</script>
